import moment from "moment";

export function zeroPadding(num, digits) {
  return (Array(digits).join("0") + num).slice(-digits);
}

export function dateToString(date, format) {
  return date ? moment(date).format(format) : null;
}
